import script from "./ActividadManualForm.vue?vue&type=script&setup=true&lang=js"
export * from "./ActividadManualForm.vue?vue&type=script&setup=true&lang=js"

import "./ActividadManualForm.vue?vue&type=style&index=0&id=728def77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-728def77"]])

export default __exports__